module.exports = __webpack_public_path__ + "img/eps.36f6a197.svg";